module.exports = __webpack_public_path__ + "static/media/eco-ecology-insect-svgrepo-com.aa7bc205.svg";